export default __webpack_public_path__ + "static/media/escuadra.48786563.png";